export default __webpack_public_path__ + "static/media/element_spec_5.19144353.webp";